<div id="stacked-bars-container">
  <h2>Stacked Bars</h2>
  <div>
    <div class="legend" style="background-color: red"></div>
    <span>Pizzas</span>
    <div class="legend" style="background-color: orange"></div>
    <span>Burgers</span>
    <div class="legend" style="background-color: #ffffbf"></div>
    <span>Beers</span>
    <div class="legend" style="background-color: darkseagreen"></div>
    <span>Salads</span>
    <div class="legend" style="background-color: dodgerblue"></div>
    <span>Shakes</span>
  </div>
  <div id="stacked-bars"></div>
</div>
